module.exports = __webpack_public_path__ + "img/watchlist-empty.4d47add1.svg";